import { z } from 'zod'
import { OptionalDateRangeSchema } from './time'
import { ReportTimePeriodSchema } from './report/kpi'

const RelativeDateRangeSchema = z.object({
  type: z.literal('relative'),
  period: ReportTimePeriodSchema,
  offset: z.number().int().optional(),
})
export type PersistedRelativeDateRange = z.infer<typeof RelativeDateRangeSchema>

const AllTimeDateRangeSchema = z.object({ type: z.literal('allTime') })
const CustomDateRangeSchema = z.object({
  type: z.literal('custom'),
  ...OptionalDateRangeSchema.shape,
})
const RollingDateRangeSchema = z.object({
  type: z.literal('rolling'),
  days: z.number().int().positive(),
})
const OlderThanDateRangeSchema = z.object({
  type: z.literal('olderThan'),
  days: z.number().int().positive(),
})

export const PersistedDateRangeSchema = z.discriminatedUnion('type', [
  AllTimeDateRangeSchema,
  RelativeDateRangeSchema,
  CustomDateRangeSchema,
  RollingDateRangeSchema,
  OlderThanDateRangeSchema,
])
export type PersistedDateRange = z.infer<typeof PersistedDateRangeSchema>
